export default {
  labels: {
    page: 'Pagina {{current}} van {{total}}',
    no_file_specified: 'Geen bestand opgegeven',
  },
  buttons: {
    previous: 'Vorige',
    next: 'Volgende',
  },
};
